module.exports = __webpack_public_path__ + "img/3.dfd0e32e.png";